import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { PATH } from 'src/constants/Path';

export const trackOpenArticle = (title: string, category: string) => {
  AnalyticsManager.instance().track(AnalyticsEvent.click_faq_content, {
    article_name: title,
    category,
    from_page:
      window.location.pathname === PATH.TRANSACTION_REPORT.accountStatement
        ? 'account_statement'
        : window.location.pathname.includes(
            PATH.RECEIVE_MONEY.VIRTUAL_ACCOUNT.path,
          )
        ? 'va'
        : 'help_and_doc',
  });
};

export const trackSearchArticle = (keyword: string, totalFound: number) => {
  AnalyticsManager.instance().track(AnalyticsEvent.click_search_faq, {
    keyword,
    total_search: totalFound,
  });
};

export const trackOpenCategory = (category: string) => {
  AnalyticsManager.instance().track(AnalyticsEvent.click_faq_content_category, {
    category,
  });
};

export const onClickGuidelines = () => {
  AnalyticsManager.instance().track(AnalyticsEvent.click_guidelines_button);
  window.open(
    'https://oyindonesia.com/id/pedoman-operasional-produk',
    '_blank',
  );
};

export const clickApiDocs = () => {
  AnalyticsManager.instance().track(AnalyticsEvent.click_shortcut_docs, {
    type: 'api',
  });
  window.open(import.meta.env.VITE_API_DOCS_URL, '_blank');
};

export const clickProductDocs = () => {
  AnalyticsManager.instance().track(AnalyticsEvent.click_shortcut_docs, {
    type: 'product',
  });
  window.open('https://docs.oyindonesia.com/#home', '_blank');
};
